import { SortOption } from './sort-options/types';
import { pushEvent } from '../../../client/data-layer';
import { Variant as VariantType, VariantGroup } from '../../../types';

// Tracks when the sorting of a product price list changes.
export const trackPriceListSortUpdate = (sort: SortOption) => {
  pushEvent('priceListSortUpdate', { sort });
};

// Tracks when the filter of a product price list changes.
export const trackPriceListFilterUpdate = (
  selectedFilter: string,
  isQuickFilter: boolean
) => {
  pushEvent('priceListFilterUpdate', { selectedFilter, isQuickFilter });
};

export const trackProductCompareTopTenLinkClick = (productId: number) =>
  pushEvent('productCompareTopTenLinkClicked', { productId });

// Tracks when a product variant is selected.
export const trackProductVariantClick = (
  group: VariantGroup,
  variant: VariantType | null
) => {
  pushEvent('priceListVariantSelected', {
    variantGroupId: group.id,
    variantGroupName: group.name,
    variantGroupType: group.type,
    variantId: variant?.id,
    variantName: variant?.name,
  });
};
